import { ContactUsService } from './@core/utils/contract-us.service';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { QRCodeModule } from 'angularx-qrcode';

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbTimepickerModule,

  NbAutocompleteModule





} from '@nebular/theme';

import { AuthInterceptor } from './_shards/authconfig.interceptor';
import { ErrorIntercept } from './_shards/./error.interceptor';

import { environment } from "../environments/environment";
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
//const config: SocketIoConfig = { url: environment.apiUrl, options: {} };
const config: any = { url: `${environment.apiUrl.includes('http') ? environment.apiUrl : 'http://localhost:3000'}`, options: { withCredentials: false, transports: ["polling"] } };

// image viewer
import { ImageViewerModule } from "ngx-image-viewer";


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbAutocompleteModule,
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    SocketIoModule.forRoot(config),
    ImageViewerModule.forRoot(),
    QRCodeModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

  bootstrap: [AppComponent,],
  providers: [
    {

      provide: HTTP_INTERCEPTORS,

      useClass: AuthInterceptor,

      multi: true

    },
    {

      provide: HTTP_INTERCEPTORS,

      useClass: ErrorIntercept,

      multi: true

    },


  ],
})
export class AppModule { }
